import { connect } from 'react-redux'
import { IStoreState } from '../../types'
import * as tripActions from '../../state/actions/trips'
import { RecurringTripModal } from '../../components/trips/RecurringTripModal'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    cronTabExp: state.tripRequest.request.crontabExp,
    timesToRecur: state.tripRequest.request.timesToRecur,
    runForever: state.tripRequest.request.runForever
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    setCronTabExpression: (cronTabExpression?: string) =>
      dispatch(tripActions.actionCreators.setCronTabExpression(cronTabExpression)),
    setRunForever: (runForever?: boolean) => dispatch(tripActions.actionCreators.setRunForever(runForever)),
    setTimesToRecur: (timeToRecur?: number) => dispatch(tripActions.actionCreators.setTimesToRecur(timeToRecur))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecurringTripModal)



// WEBPACK FOOTER //
// ./src/containers/trips/RecurringTripModal.ts